import { render, staticRenderFns } from "./FormBaseSetting.vue?vue&type=template&id=3057f5de&scoped=true"
import script from "./FormBaseSetting.vue?vue&type=script&lang=js"
export * from "./FormBaseSetting.vue?vue&type=script&lang=js"
import style0 from "./FormBaseSetting.vue?vue&type=style&index=0&id=3057f5de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057f5de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3057f5de')) {
      api.createRecord('3057f5de', component.options)
    } else {
      api.reload('3057f5de', component.options)
    }
    module.hot.accept("./FormBaseSetting.vue?vue&type=template&id=3057f5de&scoped=true", function () {
      api.rerender('3057f5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/components/FormBaseSetting.vue"
export default component.exports